/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneratedNotePagedListAdmin } from '../../models/generated-note-paged-list-admin';
import { SortDirection } from '../../models/sort-direction';

export interface SearchGeneratedNotesAll$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the notification's name
 *   * DATE : Date of the note creation
 *   * CATEGORY : Category of the note
 */
  sortFieldName?: 'NAME' | 'DATE' | 'CATEGORY';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
}

export function searchGeneratedNotesAll(http: HttpClient, rootUrl: string, params?: SearchGeneratedNotesAll$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneratedNotePagedListAdmin>> {
  const rb = new RequestBuilder(rootUrl, searchGeneratedNotesAll.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneratedNotePagedListAdmin>;
    })
  );
}

searchGeneratedNotesAll.PATH = '/notes-generated';
